import React from 'react';
import { Link } from 'react-router-dom';
import logo from '@assets/images/sage-logo-login.png';
import styles from './recover.module.scss';
import './recover-password.scss';
import { Button, Form, Input } from 'antd';
import { AuthenticationPasswordResetRequest } from '@openapi';
import { Navigation } from '@constants//Navigation';
import auth from '@services/api/auth';
import { toast } from 'react-toastify';

const RecoverPassword: React.FC = () => {
  const [form] = Form.useForm<AuthenticationPasswordResetRequest>();
  const [emailHasUppercase, setEmailHasUppercase] = React.useState(false);

  const handleFinish = async (values: AuthenticationPasswordResetRequest) => {
    await form.validateFields();
    try {
      await auth.reset(values);
      toast.success('The recovery link was sent');
      form.resetFields();
      setEmailHasUppercase(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="main-forgot-page">
      <div className="forgot-wrapper">
        <img className="logo-image" src={logo} alt="Logo Sagem" />
        <div className="recover-form">
          <Form className={styles.form} name="email recover" onFinish={handleFinish} form={form}>
            <Form.Item
              className={styles.block}
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please input your Email!',
                },
              ]}
              help={
                emailHasUppercase ? 'Email will be automatically converted to lowercase before submitting.' : undefined
              }
            >
              <Input
                type="email"
                className={styles.input}
                placeholder="Enter your email"
                onChange={(e) => {
                  const value = e.target.value;
                  setEmailHasUppercase(/[A-Z]/.test(value));
                }}
              />
            </Form.Item>
            <Form.Item className={styles.footer}>
              <Button type="primary" htmlType="submit" className={styles.buttonBlock}>
                Send
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className="back-to-login">
          <Link className="text-link" to={Navigation.Login}>
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RecoverPassword;
